import React from "react"

export class SelectionState {
  mode: SelectionMode = SelectionMode.Nothing;
}
export enum SelectionMode {
  Nothing, // nothing selected
  Partial, // partial selection, less than page
  Page,    // all rows on page selected, but not on server
  All,     // all rows on server selected
}

export type SDT = React.Dispatch<React.SetStateAction<SelectionState>>
export class SelectionApi {
  setState: SDT;
  get: () => string[];
  set: (ids: string[]) => void;
  setMode: (mode: SelectionMode) => void;
  toggleMode: () => void;
  reset: () => void;
  constructor(api: Partial<SelectionApi>) {
    this.setState = api.setState ?? (() => [])
    this.get = api.get ?? (() => [])
    this.set = api.set ?? ((ids) => {})
    this.setMode = api.setMode ?? ((mode: SelectionMode) => {})
    this.toggleMode = api.toggleMode ?? (() => {})
    this.reset = api.reset ?? (() => [])
  }
}
